import { Component,  Input } from '@angular/core';
import { publicHelpers } from 'globals/helpers/public-helpers';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'text-no-text',
    template: `
  <div *ngIf="!!greyTitle" class="greyTitle">{{ greyTitle }}</div>
  <div *ngIf="!!text" class="text" [innerHTML]="publicHelpers.strWithBreak(text)"></div>
  <div *ngIf="!text && placeholder" class="no-text">{{ placeholder }}</div>
`,
    styleUrls: ['./text-no-text.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class TextNoTextComponent {
  @Input() text: string
  @Input() greyTitle: string
  @Input() placeholder: string
  publicHelpers = publicHelpers

}

